/* eslint-disable */
import React from "react";
import BrandfolderList from "./brandfolder_list";

export default class OptionsMenu extends React.Component {
    state = {
        brandfolder_list_open: false
    };

    syncLinkedFiles = () => {
        window.syncLinkedFiles();
        this.props.toggleMenu();
    };

    toggleBrandfolderList = () => {
        this.setState({
            brandfolder_list_open: !this.state.brandfolder_list_open
        });
    };

    logout = () => {
        window.location = `/api/adobe_plugin/${
            this.props.adobe_application
        }/signout`;
    };

    renderBrandfolderList() {
        if (
            !this.props.selected_brandfolder ||
            this.state.brandfolder_list_open
        ) {
            return (
                <BrandfolderList
                    jwt={this.props.jwt}
                    selected_brandfolder={this.props.selected_brandfolder}
                    selectBrandfolder={this.props.selectBrandfolder}
                    toggleBrandfolderList={this.toggleBrandfolderList}
                />
            );
        } else {
            return (
                <div className="adobe-options-list">
                  <ul>
                    <li onClick={this.props.toggleMenu}>
                      <span className="bff-arrow-left" />Back to Files
                    </li>
                    <li onClick={this.syncLinkedFiles}>
                      <span className="bff-refresh" />Sync Linked Files
                    </li>
                    <li onClick={this.toggleBrandfolderList}>
                      <span className="bff-grid-view" /> Change Brandfolder
                    </li>
                    <li onClick={this.logout}>
                      <span className="bff-check-in" /> Logout
                    </li>
                  </ul>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="adobe-options-menu">
                {this.renderBrandfolderList()}
            </div>
        );
    }
}
